export enum NavActions {
    Start = "start",
    Continue = "continue",
    Previous = "previous",
    Exit = "exit",
    ExitAll = "exit_all",
    Abandon = "abandon",
    AbandonAll = "abandon_all",
    Choice = "choice",
    ResumeAll = "resume_all",
    Forward = "forward",
    Backward = "backward",
    SuspendAll = "suspend_all"
};
